import React, { useEffect, useRef, useState } from "react";
import { useSocket } from "../../hooks/useSocket";
import useUserStore from "../../stores/store";
import useGeneralStore from "../../stores/useGeneralStore";
import { processAndPrint, processAndPrintSalesSummary } from "../../services/print-sevice/print";

const QzTrayPrintCommandReceiverSocket = ({}) => {
  const socket = useSocket(`${process.env.REACT_APP_IMAGE_BASE_URL}`);
  const { restaurantSlug, showNotification } = useUserStore();
  const { deviceId, setDeviceId } = useGeneralStore();

  useEffect(() => {
    if (!deviceId) {
      setDeviceId(crypto.randomUUID());
    }
  }, [deviceId]);

  // Auto Print
  useEffect(() => {
    if (!socket || !restaurantSlug) {
      return;
    }

    console.log("----------auto print socket initialized---------");

    const eventNameAutoPrint = `${restaurantSlug}-auto-print-command-v2`;
    const socketHandlerAutoPrint = (data) => {
      console.log(`Event:${eventNameAutoPrint} received. data=`, data);

      processAndPrint(data, showNotification, true);
    }

    socket.on(eventNameAutoPrint, socketHandlerAutoPrint);
    
    const eventNamePrintSalesSummary = `${restaurantSlug}-print-sales-summary`;
    const socketHandlerPrintSalesSummary = (data) => {
      console.log(`Event:${eventNamePrintSalesSummary} received. data=`, data);

      processAndPrintSalesSummary(data, showNotification);
    }

    socket.on(eventNamePrintSalesSummary, socketHandlerPrintSalesSummary);


    return () => {
      console.log('----Socket off auto print', {eventNameAutoPrint});
      socket.off(eventNameAutoPrint, socketHandlerAutoPrint);
    };
  }, [socket, restaurantSlug]);

  // Manual Print
  useEffect(() => {
    if (!socket || !restaurantSlug || !deviceId) {
      return;
    }

    console.log("----------Manual print socket initialized---------");

    const eventNameManualPrint = `${deviceId}-${restaurantSlug}-manual-print-command-v2`;

    const socketHandlerManualPrint = (data) => {
      console.log(`Event:${eventNameManualPrint} received. data=`, data);
      processAndPrint(data, showNotification, false);
    }

    socket.on(eventNameManualPrint, socketHandlerManualPrint);

    
    return () => {
      console.log('----Socket off manual print', {eventNameManualPrint});
      socket.off(eventNameManualPrint, socketHandlerManualPrint);
    };
  }, [socket, restaurantSlug, deviceId]);

  return <></>;
};

export default QzTrayPrintCommandReceiverSocket;
